export default __webpack_public_path__ + "static/media/Sign up-cuate.1f8e78df.svg";